"use client";

import React from "react";
import { Card } from "./ui/card";
import bank from "../assets/images/bankComplete.png";
import { Button } from "./ui/button";
import { SecuredFooter } from "./ui/secured-footer";

const BankAddComplete = ({ onDone }) => {
  return (
    <Card className="w-full bg-white rounded-2xl !shadow-none pt-16 flex flex-col items-center text-center">
      {/* Success Image */}
      <div className="flex flex-col items-center justify-center px-6">
        <img
          src={bank}
          alt="Purchase Success"
          width={150}
          height={150}
          className="mb-6"
        />

        {/* Success Message */}
        <h2 className="text-[32px] font-semibold text-[#33125F] mb-4">
          Bank account details added!
        </h2>
        <p className="text-[20px] font-normal text-[#423E51] mb-10">
          You can now withdraw funds from your Digital Wallet into your personal
          bank account.
        </p>
      </div>

      {/* Done Button */}
      <Button
        onClick={onDone}
        className="px-6 py-4 rounded-full font-semibold transition-opacity w-full sm:min-w-[302px] max-w-sm h-[48px] text-sm sm:text-base bg-[linear-gradient(86.72deg,#57249C_-10.66%,#EB3366_113.47%)] text-white hover:opacity-90 mx-auto mb-10"
      >
        Done
      </Button>

      {/* Secured Footer */}
      <div className="w-full">
        <SecuredFooter className="mt-6" />
      </div>
    </Card>
  );
};

export default BankAddComplete;
